"use client";

import { c as _c } from "react/compiler-runtime";
import { useMapUrlSync } from "@/hooks/use-map-url-sync";
interface InitialCoordinateSyncProps {
  backendMapCenter?: {
    lat: number;
    lng: number;
  } | null;
  coordinates?: {
    lat: number;
    lng: number;
  } | null;
}

/**
 * Client component that handles initial coordinate URL synchronization
 * Task 1: Add coordinates to URL on initial load using backendMapCenter
 */
export function InitialCoordinateSync(t0) {
  const $ = _c(3);
  const {
    backendMapCenter,
    coordinates
  } = t0;
  let t1;
  if ($[0] !== backendMapCenter || $[1] !== coordinates) {
    t1 = {
      backendMapCenter,
      coordinates
    };
    $[0] = backendMapCenter;
    $[1] = coordinates;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useMapUrlSync(t1);
  return null;
}